import * as React from "react";
import TileImage from "@src/stories/components/Tile/TileImage";
import TileContent from "@src/stories/components/Tile/TileContent";
import {getPadding, getTileClasses} from "@src/stories/components/Tile/TileMethods";

const Overlayed = ({ data, height, settings, isMobile, onColumnClick, columnIndex, sectionId }) => {
    const paddingContent = getPadding(data);
    const tileClasses = getTileClasses(data, isMobile, paddingContent);

    const handleTileClick = () => {
        // Track GA4 select_promotion event (sendGtagEvent will handle navigation)
        if (onColumnClick) {
            onColumnClick();
        }
    };

    const tileContent = (
        <div className={`tileitem tileitem-overlayed color-${data.color_schema} ${data.settings.padding_area == "outside" && paddingContent}`}>
            <TileImage data={data} height={height} isMobile={isMobile} />
            <div className={`tile__info ${data.settings.image ? "flex absolute w-full z-[5]" : ""} ${tileClasses}`}>
                <TileContent data={data} isMobile={isMobile} />
            </div>
        </div>
    );

    return (
        <>
            {data.settings.make_tile_clickable ? (
                <div
                    onClick={handleTileClick}
                    className={`custom-class ${data.settings.main_aspect_ratio && data.settings.aspect_ratio_type }`}
                    style={{ cursor: "pointer", height: "100%", width: "100%" }}
                >
                    {tileContent}
                </div>
            ) : (
                <div onClick={onColumnClick} className="flex items-center justify-center w-full h-full">
                    {tileContent}
                </div>
            )}
        </>
    );
};

export default Overlayed;
